// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import { connect } from 'react-redux';
import AssignChangeForm from '../../components/order/AssignChangeForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {orderAddItem, orderSetItem, orderGetItem,orderItemId,orderGetAssignItem} from "../../actions/orderActions";
import moment from 'jalali-moment'
import * as tz from 'moment-timezone';


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.order.getItem,
        userValue : state.app.currentUser,
        userList     : state.user.list,
        orderAssignItem : state.order.orderAssignItem,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },
    setOrderId: (orderId) => {
        return(dispatch(orderItemId(orderId)))
    },
    showTechnicianAssignInfo: (userId) => {
        return(dispatch(technicianAssignInfo(userId)))
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode == 'edit')
            dispatch(edit(value));
        else
            dispatch(add(value));
    }

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {

    return (dispatch, getState) => {
        //convert date
        let minute = '00';
        let hour = '1';
        if(values.hour)
            hour = values.hour

        if(values.minute)
            minute = values.minute
        let date = values.year+'/'+values.month+'/'+values.day
        let m = moment(date, 'jYYYY-jM-jD');
        //convert time
        let time = hour+':'+minute

        let states = getState();

        let orderId;
        if(states.order.orderItemId)
            orderId = states.order.orderItemId
        else{
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'درخواست نامعتبر میباشد'
            })
        }

        let formData = {
            'schedule_time' : m._d,
            'schedule_hour' : time,
            'technician_by' : values.technician_by,
            'description':values.description?values.description:values.order.description,
            isForce:values.isForce,
            tekDescription:values.tekDescription
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('order/assign-change/'+orderId, formData).then(res => {

            dispatch(orderAddItem(res.data));
            if(res.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/order/list'}), 100)
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const edit = (values) => {
    let id = values._id;

    return (dispatch, getState) => {
        let formData = {
            'title'    : values.title,
            'cityId'   : values.city._id,
            'stateId'  : values.state._id,
            'price'    : parseInt(values.price),
            'commuting': parseInt(values.commuting)
        };
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('service-type/'+id, formData).then(editRes => {
            dispatch(orderSetItem(editRes.data));
            if(editRes.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('order/'+id).then(orderInfo => {
            dispatch(orderGetItem(orderInfo.data.result));
        }).catch(error => {
            console.log(error);
        });
    }
}

const technicianAssignInfo = (userId) => {
    return (dispatch, getState) => {
        let param = {
            technician_by:userId,
            current_status: "ORDER_ASSIGNED"
        }
        API_FETCH.get('order',{params:param}).then(list => {
            dispatch(orderGetAssignItem(list.data));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AssignChangeForm);
